import { Select } from '@shared/ui/Inputs';
import { useLanguage } from '@/feature/lang';
import { languages } from '@/feature/lang/config';

export function LangSelector() {
  const { changeLanguage, language } = useLanguage();

  return (
    <Select
      variant="filled"
      fullWidth={false}
      margin="none"
      rounded
      value={language ?? 'en'}
      onChange={(e) => {
        changeLanguage(String(e.target.value));
      }}
      sx={{ width: '75px' }}
      options={languages}
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.displayName}
      renderValue={(option) => option?.name}
      slotProps={{
        input: {
          sx: {
            '.MuiSelect-select': {
              minHeight: 'unset !important',
            },
            '.MuiSelect-select > .MuiTypography-root': {
              overflow: 'visible',
              textOverflow: 'clip',
            },
          },
        },
      }}
    />
  );
}
